import { matchIdentity } from "../../utils/curatedSearch.js";
import { LEASE_DISPLAY } from "../../utils/leaseTypeConstants.js";
import { statusFor } from "./pages/components/LeasePortfolioFilters.jsx";
import { LEASE_STATUS_LABELS as STATUS_LABELS } from "./leaseStatusLabels.js";

const SHORT_TYPES = {
  serviced_office: "Serviced", sublease_outbound: "Sub (Out)", sublease_inbound: "Sub (In)",
};

export function matchLeaseIdentity(lease, query, { arrangementVisible = true, termVisible = true } = {}) {
  const label = lease.city || lease.locationId;
  const statusLabel = STATUS_LABELS[statusFor(lease)];
  return matchIdentity(query, [
    { value: label ? `${label}${lease.locationAlias ? ` · ${lease.locationAlias}` : ""}` : null,
      primary: true, visible: true },
    ...[label, lease.locationAlias].map((value) => ({ value, primary: true, visible: true })),
    ...[lease.id, lease.locationId, lease.leaseIdSpacebase, lease.address,
      lease.name, lease.displayName, lease.buildingName, lease.propertyName].map((value) => ({ value, primary: true })),
    { value: lease.market },
    { value: lease.region },
    { value: lease.landlord },
    { value: lease.vendor },
    { value: lease.lessee },
    { value: lease.ownerName || lease.owner },
    { value: lease.suite },
    ...(Array.isArray(lease.areas) ? lease.areas : []).map((area) => ({ value: area?.name })),
    { value: LEASE_DISPLAY[lease.leaseType] },
    { value: SHORT_TYPES[lease.leaseType] || LEASE_DISPLAY[lease.leaseType], visible: arrangementVisible },
    { value: lease.leaseType, displayValue: LEASE_DISPLAY[lease.leaseType] || lease.leaseType },
    { value: statusLabel, visible: true },
    { value: statusFor(lease), displayValue: statusLabel },
    { value: lease.status, displayValue: statusLabel || lease.status },
    { value: lease.leaseStatus, displayValue: statusLabel || lease.leaseStatus },
    { value: lease.termType, visible: termVisible },
  ]);
}
